export const SESSION_LOADING = 'SESSION_LOADING';
export const SESSION_RECEIVED = 'SESSION_RECEIVED';
export const SET_PASSWORD_ERROR = 'SET_PASSWORD_ERROR';
export const SESSION_AUTH_INVALID = 'SESSION_AUTH_INVALID';
export const SESSION_AUTH_RECEIVED = 'SESSION_AUTH_RECEIVED';
export const SESSION_GET_LOADING = 'SESSION_GET_LOADING';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const SESSION_RESET_SUCCESS = 'SESSION_RESET_SUCCESS';
export const SESSION_RESET_LOADING = 'SESSION_RESET_LOADING';
export const SESSION_DETAILS_LOADING = 'SESSION_DETAILS_LOADING';
export const SESSION_VERIFY_RECEIVED = 'SESSION_VERIFY_RECEIVED';
export const SESSION_REGISTRATION_RESET = 'SESSION_REGISTRATION_RESET';
export const SESSION_SET_PASSWORD_SUCCESS = 'SESSION_SET_PASSWORD_SUCCESS';
export const SESSION_REGISTRATION_RECEIVED = 'SESSION_REGISTRATION_RECEIVED';

export const COUNCILS_ERROR = 'COUNCILS_ERROR';
export const COUNCIL_ERROR = 'COUNCIL_ERROR';
export const COUNCIL_LOADING = 'COUNCIL_LOADING';
export const COUNCILS_LOADING = 'COUNCILS_LOADING';
export const COUNCIL_RECEIVED = 'COUNCIL_RECEIVED';
export const COUNCILS_RECEIVED = 'COUNCILS_RECEIVED';

export const MESSAGE_SET = 'MESSAGE_SET';
export const MESSAGE_CLEAR = 'MESSAGE_CLEAR';

export const ERROR_SET = 'ERROR';
export const ERROR_CLEAR = 'ERROR_CLEAR';
export const ERROR_INPUT_CLEAR = 'ERROR_INPUT_CLEAR';

export const ORDER_UPDATED = 'ORDER_UPDATED';
export const ORDER_CREATED = 'ORDER_CREATED';
export const ORDERS_ERROR = 'ORDERS_ERROR';
export const ORDER_ERROR = 'ORDER_ERROR';
export const ORDER_CREATE = 'ORDER_CREATE';
export const ORDER_UPDATE = 'ORDER_UPDATE';
export const ORDER_DELETE = 'ORDER_DELETE';
export const ORDER_LOADING = 'ORDER_LOADING';
export const ORDER_RECEIVED = 'ORDER_RECEIVED';
export const ORDERS_LOADING = 'ORDERS_LOADING';
export const ORDERS_RECEIVED = 'ORDERS_RECEIVED';
export const ORDER_SET_ACTIVE = 'ORDER_SET_ACTIVE';
export const ORDER_UPDATE_LOADING = 'ORDER_UPDATE_LOADING';
export const ORDER_UPLOAD_LOADING = 'ORDER_UPLOAD_LOADING';
export const ORDER_DOCUMENT_RECEIVED = 'ORDER_DOCUMENT_RECEIVED';
export const ORDER_ITEMS_LOADING = 'ORDER_ITEMS_LOADING';
export const ORDER_ITEMS_RECEIVED = 'ORDER_ITEMS_RECEIVED';
export const ORDER_GET_CHECKOUT = 'ORDER_GET_CHECKOUT';
export const CHECKOUT_LOADING = 'CHECKOUT_LOADING';
export const ORDER_CHECKOUT_RECEIVED = 'ORDER_CHECKOUT_RECEIVED';

export const ADDRESSES_CLEAR = 'ADDRESSES_CLEAR';
export const ADDRESS_LOADING = 'ADDRESS_LOADING';
export const ADDRESSES_RECEIVED = 'ADDRESSES_RECEIVED';
export const ADDRESS_SEARCH_ERROR = 'ADDRESS_SEARCH_ERROR';
export const ADDRESS_LOOKUP_CLEAR = 'ADDRESS_LOOKUP_CLEAR';
export const ADDRESS_SEARCH_LOADING = 'ADDRESS_SEARCH_LOADING';
export const ADDRESS_SEARCH_RECEIVED = 'ADDRESS_SEARCH_RECEIVED';
export const ADDRESS_SUGGESTION_ERROR = 'ADDRESS_SUGGESTION_ERROR';
export const ADDRESSES_SET_PAGE = 'ADDRESSES_SET_PAGE';
export const ADDRESSES_NEXT_PAGE = 'ADDRESSES_NEXT_PAGE';
export const ADDRESS_PAGE_LOADING = 'ADDRESS_PAGE_LOADING';

export const CARD_LOADING = 'CARD_LOADING';
export const CARD_RECEIVED = 'CARD_RECEIVED';

export const AUTH_ERROR = 'AUTH_ERROR';
export const CARD_ERROR = 'CARD_ERROR';
export const VERIFY_ERROR = 'VERIFY_ERROR';
export const ACCOUNT_ERROR = 'ACCOUNT_ERROR';
export const AUTH_INVALID_ERROR = 'AUTH_INVALID_ERROR';
export const REGISTRATION_ERROR = 'REGISTRATION_ERROR';

export const USERS_ERROR = 'USERS_ERROR';
export const USERS_LOADING = 'USERS_LOADING';
export const USERS_RECEIVED = 'USERS_RECEIVED';
export const USERS_INVITE_SENT = 'USERS_INVITE_SENT';
export const USERS_INVITE_ERROR = 'USERS_INVITE_ERROR';
export const USERS_INVITE_LOADING = 'USERS_INVITE_LOADING';
export const USER_INVITES_RECEIVED = 'USER_INVITES_RECEIVED';

export const INVITATIONS_RECEIVED = 'INVITATIONS_RECEIVED';
export const INVITATIONS_LOADING = 'INVITATIONS_LOADING';
export const INVITATIONS_ERROR = 'INVITATIONS_ERROR';
export const INVITE_UPDATED = 'INVITE_UPDATED';
export const INVITE_RESPONSE_ERROR = 'INVITE_RESPONSE_ERROR';
export const INVITE_RESPONSE_LOADING = 'INVITE_RESPONSE_LOADING';
export const INVITATION_ERROR = 'INVITATION_ERROR';
export const INVITATION_LOADING = 'INVITATION_LOADING';
export const INVITATION_RECEIVED = 'INVITATION_RECEIVED';
export const INVITATION_ERROR_CLEAR = 'INVITATION_ERROR_CLEAR';

export const PERSIST_REHYDRATE = 'persist/REHYDRATE';

export const CONNECT_ERROR = 'CONNECT_ERROR';
export const CONNECT_LOADING = 'CONNECT_LOADING';
export const CONNECT_SUCCESS = 'CONNECT_SUCCESS';

export const OAUTH_ERROR = 'OAUTH_ERROR';
export const OAUTH_LOADING = 'OAUTH_LOADING';
export const OAUTH_CLIENT_RECEIVED = 'OAUTH_CLIENT_RECEIVED';

export const STRATAS_ERROR = 'STRATAS_ERROR';
export const STRATA_ERROR = 'STRATA_ERROR';
export const STRATA_LOADING = 'STRATA_LOADING';
export const STRATAS_LOADING = 'STRATAS_LOADING';
export const STRATA_RECEIVED = 'STRATA_RECEIVED';
export const STRATAS_RECEIVED = 'STRATAS_RECEIVED';